(function () {
  'use strict';

  var API_URL = 'https://track.rebodi.store/api/track';
  var TIMEOUT_MS = 12000;
  var MAX_IDENTIFIER_LENGTH = 80;
  var MAX_EMAIL_LENGTH = 254;
  var STAGES = ['Procesando', 'Pedido realizado', 'En tránsito', 'En reparto', 'Entregado'];
  var INVALID_ERROR = 'Los datos ingresados no son válidos. Revisa la información e inténtalo nuevamente.';
  var NOT_FOUND_ERROR = 'No encontramos un pedido con esos datos. Revisa la información e inténtalo nuevamente.';
  var RATE_LIMIT_ERROR = 'Has realizado demasiados intentos. Espera un momento y vuelve a intentarlo.';
  var TEMPORARY_ERROR = 'El seguimiento no está disponible temporalmente. Inténtalo nuevamente más tarde.';
  var TECHNICAL_ERROR = 'No pudimos procesar la solicitud. Inténtalo nuevamente más tarde.';

  function textValue(value, maxLength) {
    if (typeof value !== 'string') return '';
    return value.trim().slice(0, maxLength || 500);
  }

  function safeHttpsUrl(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      var url = new URL(value);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_error) {
      return '';
    }
  }

  function formatDate(value, includeTime) {
    if (typeof value !== 'string' || !value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    var options = { timeZone: 'America/Santiago', day: '2-digit', month: 'short', year: 'numeric' };
    if (includeTime) {
      options.hour = '2-digit';
      options.minute = '2-digit';
    }
    return new Intl.DateTimeFormat('es-CL', options).format(date);
  }

  function appendTextElement(parent, tagName, className, text) {
    var element = document.createElement(tagName);
    element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function initTrackingPage(root) {
    var form = root.querySelector('[data-tp-form]');
    if (!form) return;

    var apiUrl = root.getAttribute('data-tracking-api-url') || '';
    var orderInput = root.querySelector('[data-tp-order]');
    var emailInput = root.querySelector('[data-tp-email]');
    var msgEl = root.querySelector('[data-tp-msg]');
    var submitBtn = root.querySelector('[data-tp-submit]');
    var submitLabel = root.querySelector('[data-tp-submit-label]');
    var resultsEl = root.querySelector('[data-tp-results]');
    var resultsHeading = root.querySelector('[data-tp-results-heading]');
    var orderNumberEl = root.querySelector('[data-tp-order-number]');
    var statusEl = root.querySelector('[data-tp-status]');
    var timelineEl = root.querySelector('[data-tp-timeline]');
    var productsBlock = root.querySelector('[data-tp-products-block]');
    var productsEl = root.querySelector('[data-tp-products]');
    var destinationBlock = root.querySelector('[data-tp-destination-block]');
    var destinationEl = root.querySelector('[data-tp-destination]');
    var trackingBlock = root.querySelector('[data-tp-tracking-block]');
    var trackingNumberRow = root.querySelector('[data-tp-tracking-number-row]');
    var trackingNumberEl = root.querySelector('[data-tp-tracking-number]');
    var carrierRow = root.querySelector('[data-tp-carrier-row]');
    var carrierEl = root.querySelector('[data-tp-carrier]');
    var trackingLink = root.querySelector('[data-tp-tracking-link]');
    var updatedBlock = root.querySelector('[data-tp-updated-block]');
    var updatedEl = root.querySelector('[data-tp-updated]');
    var defaultLabel = submitLabel ? submitLabel.textContent : 'Ver';
    var requestInFlight = false;

    function setMessage(text, state, focusMessage) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      if (state) msgEl.setAttribute('data-state', state);
      else msgEl.removeAttribute('data-state');
      if (focusMessage && typeof msgEl.focus === 'function') msgEl.focus();
    }

    function setBusy(isBusy) {
      requestInFlight = isBusy;
      if (!submitBtn) return;
      submitBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      submitBtn.disabled = isBusy;
      if (submitLabel) submitLabel.textContent = isBusy ? 'Buscando pedido…' : defaultLabel;
    }

    function resetResults() {
      if (resultsEl) resultsEl.hidden = true;
      if (orderNumberEl) orderNumberEl.textContent = '';
      if (statusEl) statusEl.textContent = '';
      if (timelineEl) timelineEl.replaceChildren();
      if (productsEl) productsEl.replaceChildren();
      if (productsBlock) productsBlock.hidden = true;
      if (destinationEl) destinationEl.textContent = '';
      if (destinationBlock) destinationBlock.hidden = true;
      if (trackingNumberEl) trackingNumberEl.textContent = '';
      if (trackingNumberRow) trackingNumberRow.hidden = true;
      if (carrierEl) carrierEl.textContent = '';
      if (carrierRow) carrierRow.hidden = true;
      if (trackingLink) {
        trackingLink.hidden = true;
        trackingLink.removeAttribute('href');
      }
      if (trackingBlock) trackingBlock.hidden = true;
      if (updatedEl) updatedEl.textContent = '';
      if (updatedBlock) updatedBlock.hidden = true;
    }

    function renderTimeline(order) {
      if (!timelineEl) return;
      var currentStage = Number(order.currentStage);
      if (!Number.isInteger(currentStage)) currentStage = 0;
      currentStage = Math.max(0, Math.min(4, currentStage));
      var responseStages = Array.isArray(order.stages) ? order.stages : [];
      for (var index = 0; index < STAGES.length; index += 1) {
        var step = document.createElement('li');
        step.className = 'tp-timeline__step';
        if (index <= currentStage) step.classList.add('is-active');
        var dot = document.createElement('span');
        dot.className = 'tp-timeline__dot';
        dot.setAttribute('aria-hidden', 'true');
        step.appendChild(dot);
        appendTextElement(step, 'span', 'tp-timeline__label', STAGES[index]);
        var occurredAt = responseStages[index] && responseStages[index].occurredAt;
        var formattedDate = formatDate(occurredAt, false);
        if (formattedDate) appendTextElement(step, 'span', 'tp-timeline__date', formattedDate);
        timelineEl.appendChild(step);
      }
    }

    function renderProducts(items) {
      if (!productsEl || !productsBlock || !Array.isArray(items)) return;
      var rendered = 0;
      items.forEach(function (item) {
        if (!item || typeof item !== 'object') return;
        var title = textValue(item.title, 300);
        if (!title) return;
        var product = document.createElement('div');
        product.className = 'tp-package__product';
        var imageUrl = safeHttpsUrl(item.imagePath);
        if (imageUrl) {
          var image = document.createElement('img');
          image.className = 'tp-package__thumb';
          image.src = imageUrl;
          image.alt = textValue(item.imageAlt, 300) || title;
          image.width = 80;
          image.height = 80;
          image.loading = 'lazy';
          image.addEventListener('error', function () { image.remove(); });
          product.appendChild(image);
        }
        var details = document.createElement('div');
        appendTextElement(details, 'p', 'tp-package__label', 'Producto');
        appendTextElement(details, 'p', 'tp-package__value', title);
        var quantity = Number(item.quantity);
        if (Number.isInteger(quantity) && quantity > 0) {
          appendTextElement(details, 'p', 'tp-package__label', 'Cantidad: ' + quantity);
        }
        product.appendChild(details);
        productsEl.appendChild(product);
        rendered += 1;
      });
      productsBlock.hidden = rendered === 0;
    }

    function renderTracking(order) {
      if (!trackingBlock) return;
      var number = textValue(order.trackingNumber, 200);
      var carrier = textValue(order.carrier, 100);
      var url = safeHttpsUrl(order.trackingUrl);
      if (trackingNumberEl && trackingNumberRow && number) {
        trackingNumberEl.textContent = number;
        trackingNumberRow.hidden = false;
      }
      if (carrierEl && carrierRow && carrier) {
        carrierEl.textContent = carrier;
        carrierRow.hidden = false;
      }
      if (trackingLink && url) {
        trackingLink.href = url;
        trackingLink.hidden = false;
      }
      trackingBlock.hidden = !number && !carrier && !url;
    }

    function renderOrder(order) {
      if (!order || typeof order !== 'object') return false;
      var orderNumber = textValue(order.orderNumber, 100);
      var status = textValue(order.status, 100);
      if (!orderNumber || !status || !resultsEl) return false;
      if (orderNumberEl) orderNumberEl.textContent = orderNumber;
      if (statusEl) statusEl.textContent = status;
      renderTimeline(order);
      renderProducts(order.items);
      var destination = textValue(order.destination, 300);
      if (destinationEl && destinationBlock && destination) {
        destinationEl.textContent = destination;
        destinationBlock.hidden = false;
      }
      renderTracking(order);
      var updatedAt = formatDate(order.updatedAt, true);
      if (updatedEl && updatedBlock && updatedAt) {
        updatedEl.textContent = updatedAt;
        updatedBlock.hidden = false;
      }
      resultsEl.hidden = false;
      if (resultsHeading && typeof resultsHeading.focus === 'function') resultsHeading.focus();
      return true;
    }

    function messageForStatus(status) {
      if (status === 400) return INVALID_ERROR;
      if (status === 404) return NOT_FOUND_ERROR;
      if (status === 405) return TECHNICAL_ERROR;
      if (status === 429) return RATE_LIMIT_ERROR;
      if (status === 500 || status === 502 || status === 503 || status === 504) return TEMPORARY_ERROR;
      return TEMPORARY_ERROR;
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (requestInFlight) return;
      resetResults();
      var identifier = orderInput ? orderInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim().toLowerCase() : '';
      if (!identifier || !email || identifier.length > MAX_IDENTIFIER_LENGTH || email.length > MAX_EMAIL_LENGTH) {
        setMessage(INVALID_ERROR, 'error', true);
        return;
      }
      if (apiUrl !== API_URL || typeof AbortController === 'undefined') {
        setMessage(TECHNICAL_ERROR, 'error', true);
        return;
      }
      var controller = new AbortController();
      var timeoutId = window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS);
      setMessage('Buscando pedido…');
      setBusy(true);
      try {
        var response = await fetch(apiUrl, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ identifier: identifier, email: email }),
          signal: controller.signal
        });
        if (!response.ok) {
          setMessage(messageForStatus(response.status), 'error', true);
          return;
        }
        var payload;
        try {
          payload = await response.json();
        } catch (_error) {
          setMessage(TEMPORARY_ERROR, 'error', true);
          return;
        }
        if (!renderOrder(payload && payload.order)) {
          setMessage(TEMPORARY_ERROR, 'error', true);
          return;
        }
        setMessage('Pedido encontrado.', 'success');
      } catch (_error) {
        setMessage(TEMPORARY_ERROR, 'error', true);
      } finally {
        window.clearTimeout(timeoutId);
        setBusy(false);
      }
    });
  }

  function init() {
    var pages = document.querySelectorAll('[data-tracking-page]');
    for (var index = 0; index < pages.length; index += 1) initTrackingPage(pages[index]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
